import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export class DateneingabeBetrieblicheDatenSonstigeDaten extends
    React.Component<{}, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_SONSTIGE_DATEN}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_SONSTIGE_DATEN)}
                />
            </div>
        );
    }
}
